export default __webpack_public_path__ + "static/media/tuan.aa2a1cf9.jpg";